import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft } from "lucide-react";

const LOGO_URL = "/logo-infirmiers.png";

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-[#0D1C32] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Infirmiers Privés" className="h-12 mx-auto" />
        </div>

        <div className="card-dark p-8 text-center">
          <div className="w-16 h-16 bg-[#2A3A4D] rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-10 h-10 text-[#94A3B8]" />
          </div>
          
          <h1 className="text-xl font-semibold text-white mb-2">Paiement annulé</h1>
          <p className="text-[#94A3B8] mb-6">
            Vous avez annulé le paiement. Votre demande de soin reste en attente et vous pouvez reprendre le processus à tout moment.
          </p>
          
          <div className="space-y-3">
            <Link to="/dashboard">
              <Button className="btn-primary w-full">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Retour à mes demandes
              </Button>
            </Link>
          </div>
        </div>

        <p className="text-center text-sm text-[#64748B] mt-6">
          Besoin d'aide ? Contactez notre support.
        </p>
      </div>
    </div>
  );
};

export default PaymentCancel;
